import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RedeemWindow } from '../services/redeem-window';

export const redeemWindowGuard: CanActivateFn = async () => {
  const redeemWindow = inject(RedeemWindow);
  const router = inject(Router);

  await redeemWindow.ready;

  if (redeemWindow.hasActiveWindow()) {
    return true;
  }

  return router.createUrlTree(['/']);
};
